
<template>
    <div>
        <div style="display: flex; justify-content: center;">
            <h5 class="card-title">{{title}}</h5>
            <div class="ml-auto">
                <slot :form="formData" :get-data="getM" :get-file="getF" :loading="loading" name="buttons">
                    <button class="btn btn-sm btn-info"
                        id="searchAlumnosButton"
                        :disabled="loading"
                        @click="getM()">
                        <i class="mr-1 fas fa-search"></i>
                        Buscar
                    </button>
                    <button class="btn btn-sm btn-success"
                        v-if="viewData.length"
                        :disabled="loading"
                        id="crearFileExcel"
                        @click="getF()">
                        <i class="mr-1 fas fa-download"></i>
                        Descargar excel
                    </button>
                    <i class="fa fa-spin fa-spinner" id="spinnerTime" hidden ></i>
                </slot>
            </div>
        </div>

        <div class="row">
            <slot :form="formData" :headers-url="getHeaders" name="search" >
                <k-select-multiple
                    title="Headers"
                    v-model="formData.headers"
                    :get="getHeaders"
                    id="headers"
                    name="headers"
                    multiple
                    styles="selectpicker col-12"
                    parent-styles="col-xs-12 col-md-6 col-lg-4 component-select"
                    data-box="true"
                    clean="false"
                    >
                </k-select-multiple>
            </slot>
            <slot :show-data="viewData" :form="formData" :headers="headerSelected" :response="responseData" :item-value="itemValue" name="table" >
                    <table class="table table-hover table-bordered table-responsive">
                        <thead class="thead-dark">
                                <th :width="(100/headerSelected.length || 1)+'%'" v-for="(header, i) in headerSelected" :key="i">
                                    {{header.text}}
                                </th>
                        </thead>
                        <tbody>
                            <tr v-for="(row, i) in viewData" :key="i">
                                <td v-for="(header, n) in headerSelected" :key="n">
                                    <template v-if="Array.isArray(row[header.id])">
                                        <p v-for="(field, j) in itemValue(row, header.id)" :key="j" v-text="field"></p>
                                    </template>
                                    <template v-else>
                                        {{itemValue(row, header.id || '')}}
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
            </slot>
        </div>
    </div>
</template>

<script>
import Axios from 'axios';

export default {
    props: [
        'title',
        'getFile',
        'get',
        'getHeaders',
        'optionHeaders',
        'defaultHeaders'
    ],
    data() { return {
        formData: { headers: []},
        page: 1,
        viewData: [],
        headers:[],
        loading: false,
        responseData:{}
    } },
    mounted(){
        if (this.getHeaders){
            this.getH()
        }
        if (Array.isArray(this.optionHeaders) && !this.getHeaders) {
            this.headers = this.optionHeaders
        }
        const vm = this
        this.formData.headers = this.defaultHeaders || []
        this.$on('emitRefreshSelection', function(who, val){
            this.$emit('broadcastRefreshSelection', who, val);
        });
    },
    methods: {
        getH(){
            setTimeout(() => {
                axios.get(this.getHeaders).then(res => {
                    this.headers = res.data || [];
                }).catch(e => {
                    // console.log('Error:', e);
                });
            }, 500);
        },
        getF () {
            this.loading = true
            setTimeout(() => {
                axios.get(this.getFile, {
                    responseType: 'blob',
                    params: {...this.formData},
                    // responseType: 'arraybuffer',
                }).then(response => {
                    if (response.data instanceof Blob) {
                        const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = downloadUrl;
                        var filename = "";
                        const disposition = response.headers['content-disposition'];
                        if (disposition && disposition.indexOf('attachment') !== -1) {
                            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                            const matches = filenameRegex.exec(disposition);
                            if (matches != null && matches[1]) {
                                filename = matches[1].replace(/['"]/g, '');
                                link.setAttribute('download', filename)
                            }
                        }
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    }else{
                        throw { message: 'formatError' }
                    }
                    toastr["success"]("Descarga lista", "Éxito");
                    this.loading = false;
                }).catch(e => {
                    // console.log(e)
                    toastr["error"]('Ocurrió un problema inesperado', e);
                    this.loading = false;
                });
            }, 500);
        },
        getM () {
            return new Promise(resolve => {
                this.loading = true
                setTimeout(() => {
                    axios.get(this.get, {params: {...this.formData, ...{page: this.page}}}).then(res => {
                        this.responseData = res.data || {};
                        this.viewData = res.data.data instanceof Object ? Object.values(res.data.data) :  [];
                        this.loading = false;
                    }).catch(e => {
                        this.loading = false;
                        toastr["error"]('Ocurrió un problema inesperado', 'Error');

                    });
                }, 500);
            });
        },
        itemValue (row, field) {
            if (row && row[field]){
                return row[field]
            }
            return ''
        },
        refresh () {
            this.getM();
        }
    },
    computed:{
        headerSelected () {
            return this.headers.filter( e => this.formData.headers.includes(e.id))
        }
    },
    watch:{
        getHeaders(val){
            this.getH()
        },
        defaultHeaders(val){
            this.formData.headers = Array.isArray(this.defaultHeaders) ? this.defaultHeaders : []
        }
    }
}
</script>
